<!-- version 2021/05/20 -->
<template>
    <label>{{ title }}</label>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style lang="sass" scoped>
    label
        font-weight: 300
        font-size: 16px
        color: #405E66
</style>